import { ApqModel } from "../../domain/ApqModel";
import { SectionProps } from "./SectionProps";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Select } from "@ofqual/portal-components/components/Select";
import { Controller } from "react-hook-form";
import { Grid } from "@material-ui/core";
import { fieldLabelsOfq } from "../sections/fieldLabels";
import {
  apqService,
  cachedApqPriorityService,
  cachedApqTypeService,
  cachedApqAreaForImprovementService,
} from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
// import { epaoTypeLookupService } from "../../services";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { AttachmentList } from "../common/AttachmentList";
import { Attachment } from "../../domain/Attachment";
import { useDispatch } from "react-redux";
import { deleteSelectedAttachment } from "../../redux/actions";
import { useMemo } from "react";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { aoService } from "../../services";
import { SearchField } from "@ofqual/portal-components/components/SearchField";

export const EpaoActionsRecommendations: React.FC<SectionProps<ApqModel>> = ({
  control,
  errors,
  disabled,
  user: { token },
  item,
}) => {
  // const [epaoTypeLookup] = useLookup(epaoTypeLookupService);
  const [apqTypeLookups] = useLookup({
    service: cachedApqTypeService,
    id: "id",
    label: "value",
  });
  const [apqPriorityLookups] = useLookup({
    service: cachedApqPriorityService,
    id: "id",
    label: "value",
  });
  const [apqAreaForImprovementLookups] = useLookup({
    service: cachedApqAreaForImprovementService,
    id: "id",
    label: "value",
  });

  const mappedOrgLookupService = useMemo(
    () => ({
      get: (id: string) => aoService.get(id.toString(), { token }),
      search: (params?: QueryParams) =>
        aoService.search(params || {}, { token }),
    }),
    [token]
  );

  const dispatch = useDispatch();

  const deleteAttachment = (attachment: Attachment) =>
    dispatch(deleteSelectedAttachment(attachment));

  const buildGetBlob = (blobId: string): Promise<Blob> =>
    apqService.downloadAttachment(item!.id, blobId, { token });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="epaosContacted"
          as={
            <SearchField
              label={fieldLabelsOfq.epaosContacted}
              disabled={disabled}
              datatest="epaosContacted-field"
              searchFieldVariant="multiple"
              service={mappedOrgLookupService}
            >
              {/* {apqTypeLookups} */}
            </SearchField>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="typeId"
          as={
            <Select
              label={fieldLabelsOfq.type}
              disabled={disabled}
              datatest="typeId-field"
            >
              {apqTypeLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="priorityId"
          as={
            <Select
              label={fieldLabelsOfq.priority}
              disabled={disabled}
              datatest="priorityId-field"
            >
              {apqPriorityLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="areaForImprovementId"
          as={
            <Select
              label={fieldLabelsOfq.areaForImprovement}
              disabled={disabled}
              datatest="areaForImprovementId-field"
            >
              {apqAreaForImprovementLookups}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="longDescription"
          as={
            <TextField
              label={fieldLabelsOfq.longDescription}
              disabled={disabled}
              data-test="longDescription-field"
              multiline
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="ofqualOnlyFiles"
          defaultValue={[]}
          as={
            <FileInput
              multiple={true}
              dataTest="select-ofqualFiles-button"
              disabled={disabled}
            />
          }
        />
      </Grid>
      {item?.apqAttachments ? (
        <AttachmentList
          canEdit={!disabled}
          attachments={item.apqAttachments.filter(
            (file) => file.isOfqualOnly === true
          )}
          deleteAttachment={deleteAttachment}
          getBlob={buildGetBlob}
        />
      ) : null}
    </Grid>
  );
};
